import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/salesCopy';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full border-b border-line bg-surface" data-id="element-73" data-mp="1bmlievk97beo">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-74" data-mp="1gkes3ykrmnjp">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-75" data-mp="248xz8as2wua7">
          Frequently asked questions
        </p>
        <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-76" data-mp="28cvwsh1r9x15">
          Before you decide
        </h2>

        <ul className="mt-8 divide-y divide-line border-y border-line sm:mt-10" data-id="element-77" data-mp="1zh6ieryq62x9">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <li key={faq.question} data-id="element-78" data-mp="2rz0lga9bb60w" data-mpi={i}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 text-left sm:gap-6 sm:py-5" data-id="element-79" data-mp="2s03eanq73ijg">
                  <span className="font-display text-base font-semibold leading-snug text-ink sm:text-xl" data-id="element-80" data-mp="1emoiqqmxcz5j">
                    {faq.question}
                  </span>
                  <PlusIcon className={['h-5 w-5 shrink-0 text-rust transition-transform duration-200 ease-expo', isOpen ? 'rotate-45' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-81" data-mp="1oii0cofi3iu6" />
                </button>
                <AnimatePresence initial={false} data-id="element-82" data-mp="1slecbwajcgp5">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-83" data-mp="36pzxv1y2yr4">
                      <p className="pb-4 pr-6 text-[15px] leading-relaxed text-ink-soft sm:pb-5 sm:pr-10 sm:text-base" data-id="element-84" data-mp="287izdt2omv76">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}